import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ReadMore from 'components/program-marketing/read-more'
import Coach from './coach'
import Location from './location'
import Container from 'components/program-marketing/container'

const LocationSection = ({
  location,
  viewLocationDescription,
  viewContactCoach,
}) => (
  <Container color="white">
    <Box mb={2}>
      <Typography variant="h3" color="secondary">
        Location
      </Typography>
    </Box>
    <Box mb={2}>
      <Typography variant="h2">{location.name}</Typography>
    </Box>
    <Box mb={6}>
      {location.description && (
        <ReadMore
          text={location.description}
          onClick={viewLocationDescription}
          maxLine={2}
          maxLineMobile={3}
        />
      )}
    </Box>
    <Grid
      container
      direction="row"
      alignItems="stretch"
      justify="center"
      spacing={4}
    >
      <Grid item style={{ display: 'flex' }} sm={12} md={5}>
        <Coach coach={location.coach} viewContactCoach={viewContactCoach} />
      </Grid>
      <Grid item style={{ display: 'flex' }} sm={12} md={7}>
        <Location location={location} />
      </Grid>
    </Grid>
  </Container>
)

export default LocationSection
